// Styles
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import LOGO from '../../images/sign/logo.png';
import getCookie from '../Queries/getCookie';
import { useState } from 'react';
import AlertConfirm from '../AlertConfirm';
import getLogin from '../Queries/getOpenOrder';
import Alert from '../Alert';

// Images
import WHATSAPP from '../../images/whastapp.svg';
import DSA_LOGO from '../../images/DSA_LOGO.png';

export default function Footer({ screenSize, history, match }) {
  const { i18n = {}, t } = useTranslation('footer');
  const { language = '' } = i18n;
  const [openAlert, setOpenAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [nextRoute, setNextRoute] = useState('');
  const [loadingOpenCart, setLoadingOpenCart] = useState(false);
  const location = process.env.REACT_APP_COUNTRY;

  function contract() {
    if (location === 'MX') {
      history.push('contractsMX');
    } else {
      history.push('contractUS');
    }
  }

  function faq() {
    if (location === 'MX') {
      window.open('https://www.terramarbrands.com.mx/faq');
    } else {
      window.scrollTo(0, 0);
      history.push('/cart/consultancy/legal/faq_us');
    }
  }

  function privacy() {
    if (location === 'MX') {
      history.push('/cart/consultancy/legal/aviso_de_privacidad_mx');
    } else {
      window.scrollTo(0, 0);
      history.push('/cart/consultancy/legal/privacy_policy_us');
    }
  }

  function terms() {
    if (location === 'MX') {
      window.open('https://www.terramarbrands.com.mx/terms/');
    }
  }

  function california() {
    window.scrollTo(0, 0);
    history.push('/cart/consultancy/legal/california_privacy_notice');
  }

  function consultantAgreement() {
    window.scrollTo(0, 0);
    history.push('/cart/consultancy/legal/consultant_agreement_us');
  }

  function policiesAndProcedures() {
    window.scrollTo(0, 0);
    history.push('/cart/consultancy/legal/policies_and_procedures_us');
  }

  function consultantManual() {
    if (location === 'MX') {
      window.open('https://www.terramarbrands.com.mx/faq');
    } else {
      window.scrollTo(0, 0);
      // history.push('/cart/consultancy/legal/manual_us');
      if (language.includes('es'))
        window.open(
          'https://webimages.terramarbrands.com.mx/usawebpage/documents/legals/MANUAL_CONSULTORA.pdf',
        );
      else
        window.open(
          'https://webimages.terramarbrands.com.mx/usawebpage/documents/legals/CONSULTANT_MANUAL.pdf',
        );
    }
  }

  function dsaRedirect() {
    window.open('https://www.dsa.org/consumerprotection/code-of-ethics');
  }

  async function verifyCountry(e) {
    if (location === 'MX') {
      e.preventDefault();
      if (loadingOpenCart) return;
      setLoadingOpenCart(true);
      const response = await getLogin('N');
      const { getLoginResult = [] } = response || {};

      if (getLoginResult.length > 0) {
        const {
          tipoMensaje = 'error',
          folioPedido = '',
          usuarioOk = '',
          usuario = '',
          nombre = '',
          apPaterno = '',
          almacen = '',
          mensaje,
        } = getLoginResult[0];

        if (tipoMensaje === 'error' && folioPedido !== '') {
          setAlertText(t('reopen'));
          setOpenAlert(true);
        } else if (tipoMensaje === 'error' && folioPedido === '') {
          setAlertText(mensaje);
          setOpen(true);
        } else {
          const now = new Date();
          const time = now.getTime();
          const expireTime = time + 1000 * 36000;
          now.setTime(expireTime);
          document.cookie = `folioPedido=${folioPedido};expires=${now.toUTCString()};path=/`;
          document.cookie = `usuarioOk=${usuarioOk};expires=${now.toUTCString()};path=/`;
          document.cookie = `usuario=${usuario};expires=${now.toUTCString()};path=/`;
          document.cookie = `kitName=${nombre} ${apPaterno};expires=${now.toUTCString()};path=/`;
          document.cookie = `warehouse=${almacen};expires=${now.toUTCString()};path=/`;
          document.cookie = 'pedidoCerrado=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          history.push('/cart/consultancy/warehouse');
        }
        setLoadingOpenCart(false);
      } else {
        setLoadingOpenCart(false);
        setAlertText(t('loginFailed'));
        setOpen(true);
        return;
      }
    } else {
      history.push('/cart');
    }
  }

  function handelDialog(action, messaje, route) {
    if (messaje) setAlertText(messaje);
    setOpen(action);
    if (route) setNextRoute(route);
    if (!action && nextRoute) history.push(nextRoute);
  }

  return (
    <div
      className={
        screenSize !== 'phone'
          ? `${styles.Footer} ${styles[screenSize]}`
          : `${styles.FooterMobile} ${styles[screenSize]}`
      }>
      <AlertConfirm
        open={openAlert}
        setOpen={setOpenAlert}
        title='Terramar'
        text={alertText}
        usuarioOk={getCookie('usuarioOk')}
        history={history}
        setAlertText={setAlertText}
      />
      <Alert
        open={open}
        setOpen={setOpen}
        title={'Terramar'}
        text={alertText}
        callback={() => handelDialog(false)}
      />
      {screenSize !== 'phone' && (
        <>
          <div className={styles.left}>
            <div className={styles.logo}>
              <img src={LOGO} alt='logo' />
            </div>
          </div>

          <div className={styles.left}>
            <div className={styles.brandName}>{t('access')}</div>
            <div className={styles.subMenu}>
              {location === 'US' && (
                <div className={styles.link} onClick={() => consultantManual()}>
                  {t('consultantManual')}
                </div>
              )}
              <div
                className={styles.link}
                onClick={() => history.push('/cart/consultancy/shipments')}>
                {t('rastrear')}
              </div>
              <div className={styles.link} onClick={(e) => verifyCountry(e)}>
                {t('cart')}
              </div>
              <div className={styles.link} onClick={() => contract()}>
                {t('contract')}
              </div>
              <div
                className={styles.link}
                onClick={() => history.push('/cart/consultancy/accountstatus')}>
                {t('account')}
              </div>
              <div
                className={styles.link}
                onClick={() => history.push('/cart/consultancy/invoices')}>
                {t('downloadInvoice')}
              </div>
              <div
                className={styles.link}
                onClick={() => window.open('https://admin.terramarbrands.com.mx/')}>
                {t('admin')}
              </div>
            </div>
          </div>
        </>
      )}
      <div className={styles.left}>
        <div className={styles.brandName}>{t('terramar')}</div>
        <div className={styles.subMenu}>
          <div className={`${styles.menuWhitIcon} ${styles.link}`}>
            <a
              href={`mailto:${
                (location === 'MX' && 'callcenter@terramarbrands.com') ||
                'customerservice@terramarbrands.com'
              }`}
              target='_blank'
              without='true'
              rel='noopener noreferrer'>
              <i className={`material-icons ${styles.menuIcon}`}>mail_outline</i>
              {(location === 'MX' && 'callcenter@terramarbrands.com') ||
                'customerservice@terramarbrands.com'}
            </a>
          </div>
          <div className={`${styles.menuWhitIcon} ${styles.link}`}>
            <a href='tel:3332681430' target='_blank' rel='noopener noreferrer'>
              <i className={`material-icons ${styles.menuIcon}`}>call</i>
              {(location === 'MX' && '33 3268 1430') || '800-313-0903'}
            </a>
          </div>
          <div className={`${styles.menuWhitIcon} ${styles.link}`}>
            <a
              href={`https://api.whatsapp.com/send?phone=${
                (location === 'MX' && '525542477210') || '+17579331299'
              }`}
              target='_blank'
              rel='noopener noreferrer'>
              <img className={styles.menuIcon} src={WHATSAPP} alt='' />
              {(location === 'MX' && '554 247 7210') || '+1 (757) 933 1299'}
            </a>
          </div>
        </div>
      </div>

      <div className={styles.left}>
        <div className={styles.brandName}>{t('support')}</div>
        <div className={styles.subMenu}>
          <div className={styles.link} onClick={() => faq()}>
            {t('faq')}
          </div>
        </div>
      </div>

      <div className={styles.left}>
        <div className={styles.brandName}>{t('information')}</div>
        <div className={styles.subMenu}>
          {location === 'US' && (
            <div className={styles.link} onClick={() => consultantAgreement()}>
              {t('consultantAgreement')}
            </div>
          )}
          <div className={styles.link} onClick={() => privacy()}>
            {t('privacy')}
          </div>
          {location === 'MX' && (
            <div className={styles.link} onClick={() => terms()}>
              {t('terms')}
            </div>
          )}
          {location === 'US' && (
            <div className={styles.link} onClick={() => policiesAndProcedures()}>
              {t('policiesProcedures')}
            </div>
          )}
          {location === 'US' && (
            <div className={styles.link} onClick={() => california()}>
              {t('california')}
            </div>
          )}
        </div>
        <div className={`${styles.brandName} ${styles.secondBrand}`}>DSA</div>
        <div className={`${styles.subMenu} ${styles.secondSubMenu}`}>
          <div>{t('dsalabel1')}</div>
          <div>
            <span>{t('dsalabel2')} </span>
            <span className={styles.linkRedirect} onClick={() => dsaRedirect()}>
              {t('dsalabel3')}
            </span>
          </div>
          <div className={`${styles.brandLogo} ${styles.secondBrand}`}>
            <img className={styles.dsaLogo} src={DSA_LOGO} alt='DSA logo' />
          </div>
        </div>
      </div>

      <div className={styles.left}>
        <div className={styles.brandName}>{t('site')}</div>
        <div className={styles.securityIcons}>
          <i className={`material-icons-outlined ${styles.secIcon}`}>verified_user</i>
          <i className={`material-icons-outlined ${styles.secIcon}`}>lock</i>
        </div>
        <div className={styles.subMenu}>
          <div>{t('labelSite')}</div>
          <div>{t('labelSite2')}</div>
          <div>{t('labelSite3')}</div>
          <div>{t('labelSite4')}</div>
          <div>{t('labelSite5')}</div>
        </div>
      </div>
    </div>
  );
}
